define("shared/components/shared/address-fields", ["exports", "@ember/component", "@ember/service", "@ember/utils", "@glimmer/component", "later/utils/constants", "@ember/template-factory"], function (_exports, _component, _service, _utils, _component2, _constants, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/service",0,"@ember/utils",0,"@glimmer/component",0,"later/utils/constants",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="u--m__b u--block" data-test-id="address-fields" ...attributes>
    {{#if this.showLabel}}
      <label class="u--m__b__xs {{@qaClassInputLabel}}" data-test-id="shipping-address">{{this.label}}</label>
    {{/if}}
    {{#if this.showDescription}}
      <p class="u--text--sm u--text--light" data-test-id="address-tax-text">
        {{this.description}}
      </p>
    {{/if}}
  
    {{#if (and this.unsavedAddressNotFound @showErrors this.showSuggestion)}}
      <p class="u--text--danger u--m__tb__md" data-test-id="address-not-found-error">
        {{svg-jar "warning" class="o--icon o--icon--danger u--m__r__xs"}}
        {{t "errors.address.no_matches"}}
      </p>
    {{/if}}
  
    <div class="o--formWrapper u--m__b__xs" data-test-id="country-input">
      <Shared::AddressFields::Country
        @country={{@country}}
        @field={{this.addressFieldKeys.COUNTRY}}
        @isDisabled={{@isDisabled}}
        @setSelectedCountry={{@setSelectedCountry}}
        @showErrors={{@showErrors}}
        @suggestions={{this.suggestedChanges}}
      />
    </div>
  
    {{#if @showFullForm}}
      {{! Address line 1 }}
      {{#unless @hideStreetAddress}}
        {{#if this.formConfig.line1}}
          <div class="o--formWrapper u--m__b__xs" data-test-id="address-line-one-input">
            <Shared::AddressFields::Item
              @emptyText={{t "errors.address.empty.line_one"}}
              @field={{this.addressFieldKeys.LINE_ONE}}
              @invalidText={{t "errors.address.invalid_line"}}
              @isDisabled={{@isDisabled}}
              @isRequired={{includes this.addressFieldKeys.LINE_ONE this.requiredFields}}
              @placeHolder={{t "account.subscription.billing.address.address_1"}}
              @qaClass="qa--address_street"
              @setSuggestion={{@setSuggestion}}
              @showErrors={{@showErrors}}
              @showSuggestion={{this.showSuggestion}}
              @value={{@line1}}
            />
          </div>
        {{/if}}
        {{#if this.formConfig.line2}}
          {{! Address line 2 }}
          <div class="o--formWrapper u--m__b__xs">
            <Shared::AddressFields::Item
              @field={{this.addressFieldKeys.LINE_TWO}}
              @invalidText={{t "errors.address.invalid_line"}}
              @isDisabled={{@isDisabled}}
              @isRequired={{includes this.addressFieldKeys.LINE_TWO this.requiredFields}}
              @placeHolder={{t "account.subscription.billing.address.address_2"}}
              @qaClass="qa--address_unit"
              @showErrors={{false}}
              @showSuggestion={{this.showSuggestion}}
              @value={{@line2}}
            />
          </div>
        {{/if}}
      {{/unless}}
      <div class="u--row u--row--noCollapse">
        {{#if this.formConfig.city}}
          <div class={{this.inputColumnsClass}}>
            <div class="o--formWrapper u--m__b__0">
              {{! City }}
              <Shared::AddressFields::Item
                @field={{this.addressFieldKeys.CITY}}
                @invalidText={{t "errors.address.invalid_city"}}
                @isDisabled={{@isDisabled}}
                @isRequired={{includes this.addressFieldKeys.CITY this.requiredFields}}
                @placeHolder={{this.cityPlaceholderText}}
                @qaClass="qa--address_city"
                @setSuggestion={{@setSuggestion}}
                @showErrors={{@showErrors}}
                @showSuggestion={{this.showSuggestion}}
                @value={{@city}}
              />
            </div>
          </div>
        {{/if}}
        {{#if this.formConfig.state}}
          <div class="u--col__4">
            <div class="o--formWrapper u--m__b__0">
              {{! State }}
              <Shared::AddressFields::Item
                @field={{this.addressFieldKeys.STATE}}
                @invalidText={{this.invalidStateText}}
                @isDisabled={{@isDisabled}}
                @isRequired={{includes this.addressFieldKeys.STATE this.requiredFields}}
                @placeHolder={{this.statePlaceholderText}}
                @qaClass="qa--address_state"
                @setSuggestion={{@setSuggestion}}
                @showErrors={{@showErrors}}
                @showSuggestion={{this.showSuggestion}}
                @value={{@state}}
              />
            </div>
          </div>
        {{/if}}
        <div class={{this.inputColumnsClass}}>
          <div class="o--formWrapper u--m__b__0">
            {{! Zip code/Postal Code }}
            <Shared::AddressFields::Item
              @field={{this.addressFieldKeys.POSTAL_CODE}}
              @invalidText={{this.invalidPostalCodeText}}
              @isDisabled={{@isDisabled}}
              @isRequired={{includes this.addressFieldKeys.POSTAL_CODE this.requiredFields}}
              @placeHolder={{this.postalCodePlaceholderText}}
              @qaClass="qa--address_zip"
              @setSuggestion={{@setSuggestion}}
              @showErrors={{@showErrors}}
              @showSuggestion={{this.showSuggestion}}
              @value={{@postalCode}}
            />
          </div>
        </div>
      </div>
      <div class="u--row u--row--noCollapse">
        {{#if this.hasSameLineEmptyErrors}}
          <div class="u--col__12">
            <span class="o--form__helpText is--error u--m__tb__xs">{{this.sameLineErrorText}}</span>
          </div>
        {{/if}}
      </div>
    {{/if}}
  </div>
  */
  {
    "id": "H+FMv7hq",
    "block": "[[[11,0],[24,0,\"u--m__b u--block\"],[24,\"data-test-id\",\"address-fields\"],[17,1],[12],[1,\"\\n\"],[41,[30,0,[\"showLabel\"]],[[[1,\"    \"],[10,\"label\"],[15,0,[29,[\"u--m__b__xs \",[30,2]]]],[14,\"data-test-id\",\"shipping-address\"],[12],[1,[30,0,[\"label\"]]],[13],[1,\"\\n\"]],[]],null],[41,[30,0,[\"showDescription\"]],[[[1,\"    \"],[10,2],[14,0,\"u--text--sm u--text--light\"],[14,\"data-test-id\",\"address-tax-text\"],[12],[1,\"\\n      \"],[1,[30,0,[\"description\"]]],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[28,[37,1],[[30,0,[\"unsavedAddressNotFound\"]],[30,3],[30,0,[\"showSuggestion\"]]],null],[[[1,\"    \"],[10,2],[14,0,\"u--text--danger u--m__tb__md\"],[14,\"data-test-id\",\"address-not-found-error\"],[12],[1,\"\\n      \"],[1,[28,[35,2],[\"warning\"],[[\"class\"],[\"o--icon o--icon--danger u--m__r__xs\"]]]],[1,\"\\n      \"],[1,[28,[35,3],[\"errors.address.no_matches\"],null]],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n  \"],[10,0],[14,0,\"o--formWrapper u--m__b__xs\"],[14,\"data-test-id\",\"country-input\"],[12],[1,\"\\n    \"],[8,[39,4],null,[[\"@country\",\"@field\",\"@isDisabled\",\"@setSelectedCountry\",\"@showErrors\",\"@suggestions\"],[[30,4],[30,0,[\"addressFieldKeys\",\"COUNTRY\"]],[30,5],[30,6],[30,3],[30,0,[\"suggestedChanges\"]]]],null],[1,\"\\n  \"],[13],[1,\"\\n\\n\"],[41,[30,7],[[[41,[51,[30,8]],[[[41,[30,0,[\"formConfig\",\"line1\"]],[[[1,\"        \"],[10,0],[14,0,\"o--formWrapper u--m__b__xs\"],[14,\"data-test-id\",\"address-line-one-input\"],[12],[1,\"\\n          \"],[8,[39,6],null,[[\"@emptyText\",\"@field\",\"@invalidText\",\"@isDisabled\",\"@isRequired\",\"@placeHolder\",\"@qaClass\",\"@setSuggestion\",\"@showErrors\",\"@showSuggestion\",\"@value\"],[[28,[37,3],[\"errors.address.empty.line_one\"],null],[30,0,[\"addressFieldKeys\",\"LINE_ONE\"]],[28,[37,3],[\"errors.address.invalid_line\"],null],[30,5],[28,[37,7],[[30,0,[\"addressFieldKeys\",\"LINE_ONE\"]],[30,0,[\"requiredFields\"]]],null],[28,[37,3],[\"account.subscription.billing.address.address_1\"],null],\"qa--address_street\",[30,9],[30,3],[30,0,[\"showSuggestion\"]],[30,10]]],null],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[41,[30,0,[\"formConfig\",\"line2\"]],[[[1,\"        \"],[10,0],[14,0,\"o--formWrapper u--m__b__xs\"],[12],[1,\"\\n          \"],[8,[39,6],null,[[\"@field\",\"@invalidText\",\"@isDisabled\",\"@isRequired\",\"@placeHolder\",\"@qaClass\",\"@showErrors\",\"@showSuggestion\",\"@value\"],[[30,0,[\"addressFieldKeys\",\"LINE_TWO\"]],[28,[37,3],[\"errors.address.invalid_line\"],null],[30,5],[28,[37,7],[[30,0,[\"addressFieldKeys\",\"LINE_TWO\"]],[30,0,[\"requiredFields\"]]],null],[28,[37,3],[\"account.subscription.billing.address.address_2\"],null],\"qa--address_unit\",false,[30,0,[\"showSuggestion\"]],[30,11]]],null],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null]],[]],null],[1,\"    \"],[10,0],[14,0,\"u--row u--row--noCollapse\"],[12],[1,\"\\n\"],[41,[30,0,[\"formConfig\",\"city\"]],[[[1,\"        \"],[10,0],[15,0,[30,0,[\"inputColumnsClass\"]]],[12],[1,\"\\n          \"],[10,0],[14,0,\"o--formWrapper u--m__b__0\"],[12],[1,\"\\n\"],[1,\"            \"],[8,[39,6],null,[[\"@field\",\"@invalidText\",\"@isDisabled\",\"@isRequired\",\"@placeHolder\",\"@qaClass\",\"@setSuggestion\",\"@showErrors\",\"@showSuggestion\",\"@value\"],[[30,0,[\"addressFieldKeys\",\"CITY\"]],[28,[37,3],[\"errors.address.invalid_city\"],null],[30,5],[28,[37,7],[[30,0,[\"addressFieldKeys\",\"CITY\"]],[30,0,[\"requiredFields\"]]],null],[30,0,[\"cityPlaceholderText\"]],\"qa--address_city\",[30,9],[30,3],[30,0,[\"showSuggestion\"]],[30,12]]],null],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[41,[30,0,[\"formConfig\",\"state\"]],[[[1,\"        \"],[10,0],[14,0,\"u--col__4\"],[12],[1,\"\\n          \"],[10,0],[14,0,\"o--formWrapper u--m__b__0\"],[12],[1,\"\\n\"],[1,\"            \"],[8,[39,6],null,[[\"@field\",\"@invalidText\",\"@isDisabled\",\"@isRequired\",\"@placeHolder\",\"@qaClass\",\"@setSuggestion\",\"@showErrors\",\"@showSuggestion\",\"@value\"],[[30,0,[\"addressFieldKeys\",\"STATE\"]],[30,0,[\"invalidStateText\"]],[30,5],[28,[37,7],[[30,0,[\"addressFieldKeys\",\"STATE\"]],[30,0,[\"requiredFields\"]]],null],[30,0,[\"statePlaceholderText\"]],\"qa--address_state\",[30,9],[30,3],[30,0,[\"showSuggestion\"]],[30,13]]],null],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[1,\"      \"],[10,0],[15,0,[30,0,[\"inputColumnsClass\"]]],[12],[1,\"\\n        \"],[10,0],[14,0,\"o--formWrapper u--m__b__0\"],[12],[1,\"\\n\"],[1,\"          \"],[8,[39,6],null,[[\"@field\",\"@invalidText\",\"@isDisabled\",\"@isRequired\",\"@placeHolder\",\"@qaClass\",\"@setSuggestion\",\"@showErrors\",\"@showSuggestion\",\"@value\"],[[30,0,[\"addressFieldKeys\",\"POSTAL_CODE\"]],[30,0,[\"invalidPostalCodeText\"]],[30,5],[28,[37,7],[[30,0,[\"addressFieldKeys\",\"POSTAL_CODE\"]],[30,0,[\"requiredFields\"]]],null],[30,0,[\"postalCodePlaceholderText\"]],\"qa--address_zip\",[30,9],[30,3],[30,0,[\"showSuggestion\"]],[30,14]]],null],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,0],[14,0,\"u--row u--row--noCollapse\"],[12],[1,\"\\n\"],[41,[30,0,[\"hasSameLineEmptyErrors\"]],[[[1,\"        \"],[10,0],[14,0,\"u--col__12\"],[12],[1,\"\\n          \"],[10,1],[14,0,\"o--form__helpText is--error u--m__tb__xs\"],[12],[1,[30,0,[\"sameLineErrorText\"]]],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[1,\"    \"],[13],[1,\"\\n\"]],[]],null],[13]],[\"&attrs\",\"@qaClassInputLabel\",\"@showErrors\",\"@country\",\"@isDisabled\",\"@setSelectedCountry\",\"@showFullForm\",\"@hideStreetAddress\",\"@setSuggestion\",\"@line1\",\"@line2\",\"@city\",\"@state\",\"@postalCode\"],false,[\"if\",\"and\",\"svg-jar\",\"t\",\"shared/address-fields/country\",\"unless\",\"shared/address-fields/item\",\"includes\"]]",
    "moduleName": "shared/components/shared/address-fields.hbs",
    "isStrictMode": false
  });

  /**
   * @class Shared::AddressFields
   * @extends Component
   *
   * This component is collection of an address inputs for a user to enter their street address
   * On usage of this component, it needs to be wrapped in a form to handle saving or submission of the form
   *
   *  Required Arguments:
   * - [country] (String) string text of two letter country code.
   * - [line1] (String) string text of address line 1.
   * - [line2] (String) string text of address line 2 (unit number). Can be empty string.
   * - [city] (String) string text of city.
   * - [showErrors] (Boolean) used to determine if errors should be shown. Can be used so that errors are not visible on page load
   * - [state] (String) string text of state.
   * - [postalCode] (String) string text of zip or postal code.
   * - [setSelectedCountry] (Action) handler that sets country when power select dropdown is changed
   *
   * Optional Arguments:
   * - [label] (string) label text for address fields. Defaults to translation: "account.subscription.billing.address.title"
   * - [description] (string) description text for address fields. Defaults to translation: "account.subscription.billing.address.description"
   *  - [showDescription] (boolean) used to determine if description should be shown. Defaults to true
   *
   * Inline Usage with all options:
   * ```
   *<Shared::AddressFields
   *  @country={{"CA"}}
   *  @line1={{"204 address street"}}
   *  @line2={{"Unit 1"}}
   *  @city={{"City"}}
   *  @showErrors={{true}}
   *  @state={{"Kansas"}}
   *  @postalCode={{"11111"}}
   *  @setSelectedCountry={{this.setSelectedCountry}}
   * />
   * ```
   */
  let SharedAddressFieldsComponent = _exports.default = (_class = class SharedAddressFieldsComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "address", _descriptor, this);
      _initializerDefineProperty(this, "intl", _descriptor2, this);
      _defineProperty(this, "addressFieldKeys", _constants.ADDRESS_FIELD_KEYS);
    }
    get label() {
      return this.args.label || this.intl.t('account.subscription.billing.address.title');
    }
    get description() {
      return this.args.description || this.intl.t('account.subscription.billing.address.description');
    }
    get showDescription() {
      return this.args.showDescription ?? true;
    }
    get showLabel() {
      return this.args.showLabel ?? true;
    }
    get showSuggestion() {
      return this.args.showSuggestion ?? true;
    }

    /**
     * used to control form input order
     * EU Countries display the postal code before
     * the City input
     */
    get shouldReverseInputs() {
      return _constants.ADDRESS_COUNTRIES_TAXABLE_EU.includes(this.args.country);
    }
    get formConfig() {
      return {
        country: true,
        city: true,
        line1: true,
        line2: true,
        state: true,
        postalCode: true
      };
    }
    get sameLineErrorText() {
      const stateOrProvince = _constants.ADDRESS_COUNTRIES_WITH_STATE.includes(this.args.country) ? 'state' : 'province';
      let zipOrPostalCode = 'postal';
      if (this.args.country === 'US') {
        zipOrPostalCode = 'zip';
      }
      if (this.args.country === 'GB') {
        zipOrPostalCode = 'postcode';
      }
      const townOrCity = this.args.country === 'GB' ? 'town' : 'city';

      // Note: form field names to keys used in translations.
      const copyDictionary = {
        [this.addressFieldKeys.POSTAL_CODE]: this.intl.t(`errors.address.empty.${zipOrPostalCode}`),
        [this.addressFieldKeys.CITY]: this.intl.t(`errors.address.empty.${townOrCity}`),
        [this.addressFieldKeys.STATE]: this.intl.t(`errors.address.empty.${stateOrProvince}`)
      };
      const errorTranslations = Object.entries(this.emptyStatesSameLine)
      // eslint-disable-next-line no-unused-vars
      .filter(_ref => {
        let [_, value] = _ref;
        return value;
      }).map(_ref2 => {
        let [key] = _ref2;
        return copyDictionary[key];
      });
      if (errorTranslations.length > 0) {
        return this.intl.t('errors.address.empty.multi', {
          errors: errorTranslations.join(', ')
        });
      }
      return '';
    }
    get emptyStatesSameLine() {
      return {
        [this.addressFieldKeys.CITY]: this.isFieldRequiredAndEmpty(this.addressFieldKeys.CITY),
        [this.addressFieldKeys.STATE]: this.isFieldRequiredAndEmpty(this.addressFieldKeys.STATE),
        [this.addressFieldKeys.POSTAL_CODE]: this.isFieldRequiredAndEmpty(this.addressFieldKeys.POSTAL_CODE)
      };
    }
    get hasSameLineEmptyErrors() {
      return this.sameLineEmptyErrorsAmount > 0 && this.args.showErrors;
    }
    get invalidStateText() {
      const key = _constants.ADDRESS_COUNTRIES_WITH_STATE.includes(this.args.country) ? 'errors.address.invalid_state' : 'errors.address.invalid_province';
      return this.intl.t(key);
    }
    get invalidPostalCodeText() {
      const key = this.args.country === 'US' ? 'errors.address.invalid_zip_code' : 'errors.address.invalid_postal_code';
      return this.intl.t(key);
    }
    get sameLineEmptyErrorsAmount() {
      return Object.values(this.emptyStatesSameLine).filter(value => value).length;
    }
    get unsavedAddressNotFound() {
      return this.address.isUnsavedAddressNotFound;
    }
    get suggestedChanges() {
      return this.address.suggestedChanges;
    }
    get requiredFields() {
      if (this.args.requiredFields) {
        return this.args.requiredFields;
      }
      return this.address.getRequiredFields(this.args.country);
    }
    get postalCodePlaceholderText() {
      let key = 'account.subscription.billing.address.postal_code';
      if (this.args.country === 'US') {
        key = 'account.subscription.billing.address.zip_code';
      }
      if (this.args.country === 'GB') {
        key = 'account.subscription.billing.address.postcode';
      }
      return this.intl.t(key);
    }
    get statePlaceholderText() {
      const key = _constants.ADDRESS_COUNTRIES_WITH_STATE.includes(this.args.country) ? 'account.subscription.billing.address.state' : 'account.subscription.billing.address.province';
      return this.intl.t(key);
    }
    get cityPlaceholderText() {
      const key = this.args.country === 'GB' ? 'account.subscription.billing.address.town' : 'account.subscription.billing.address.city';
      return this.intl.t(key);
    }
    get inputColumnsClass() {
      return this.formConfig.state ? 'u--col__4' : 'u--col__6';
    }

    /**
     *
     * @param {string} field key of ADDRESS_FIELD_KEYS. Example: postalCode
     * @returns {boolean}
     */
    isFieldRequiredAndEmpty(field) {
      return this.requiredFields.includes(field) && !(0, _utils.isPresent)(this.args[field]);
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "address", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, SharedAddressFieldsComponent);
});